





























import SidebarDonate from "@/components/SidebarDonate.vue";

export default {
  name: "PledgeOneDollarMonthly",
  components: {
    SidebarDonate,
  },
  mounted() {

    setTimeout(function() {
      window.paypal.Buttons({
            style: {
              shape: "pill",
              color: "gold",
              layout: "vertical",
              label: "paypal",
            },
            createSubscription: function (data: any, actions: any) {
              return actions.subscription.create({
                plan_id: "P-4JW07951RH570101PL4WRD3Q",
              });
            },
            onApprove: function (data: any, actions: any) {
              alert(data.subscriptionID);
            },
          })
          .render("#paypal-button-container");

      }, 1000);
  
  },
  created() {
    let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src','https://www.paypal.com/sdk/js?client-id=ARnUgIj9Ic8-2NU0cRFIsxA_ri9v7AzXPYRkW44yyHFJq5Pj43yWbjiBxHK7jrPZOkPFn1EKApvVBONs&vault=true')
      document.head.appendChild(recaptchaScript);
  },
/*
  created() {
    this.$loadScript(
      "https://www.paypal.com/sdk/js?client-id=ARnUgIj9Ic8-2NU0cRFIsxA_ri9v7AzXPYRkW44yyHFJq5Pj43yWbjiBxHK7jrPZOkPFn1EKApvVBONs&vault=true"
    )
      .then(() => {
        paypal
          .Buttons({
            style: {
              shape: "pill",
              color: "gold",
              layout: "vertical",
              label: "paypal",
            },
            createSubscription: function (data: any, actions: any) {
              return actions.subscription.create({
                plan_id: "P-4JW07951RH570101PL4WRD3Q",
              });
            },
            onApprove: function (data: any, actions: any) {
              alert(data.subscriptionID);
            },
          })
          .render("#paypal-button-container");
      })
      .catch(() => {
        // Failed to fetch script
      });
  },
  */
};
